
// IMPORT DEPENDENCIES
import "../../node_modules/picturefill/dist/picturefill.min.js";


// IMPORT MODULES


// JQUERY DOCUMENT READY
$(document).ready(function () {

    picturefill();

    // menu layer
    $('.js-nav, .overlay').on('click', function(e) {
        e.preventDefault();

        if($('.js-nav').hasClass('active')) {
            $('.js-nav').addClass('inactive').removeClass('active');
            $('body').removeClass('nav-open');
        }else{
            $('.js-nav').addClass('active').removeClass('inactive');
            $('body').addClass('nav-open');
        }
    });

    //menu toggle
    $('.js-nav-toggle').on('click', function(e) {
        e.preventDefault();
        $(this).parent().toggleClass('active').siblings().removeClass('active');
    });

});


// JQUERY WINDOW ON LOAD
$(window).on('load', function () {


});

// JQUERY WINDOW RESIZE
$(window).resize(function () {


});

// Window focus
$(window).on('focus', function () {


});

// https://github.com/louisremi/jquery-smartresize
$(window).on('debouncedresize', function () {


});

// ORIENTATIONCHANGE
var addEvent = window.attachEvent || window.addEventListener;
addEvent("orientationchange", function () {


}, false);
